module.exports = __webpack_public_path__ + "img/pinheiro.b1988a16.png";